export const parseTimeString = (timeStr) => {
  try {
    if (!timeStr || typeof timeStr !== 'string') return null;
    
    const parts = timeStr.trim().split(' ');
    if (parts.length !== 2) return null;
    
    const [time, period] = parts;
    if (!time || !period) return null;
    
    const [hours, minutes] = time.split(':').map(num => parseInt(num, 10));
    if (isNaN(hours) || isNaN(minutes)) return null;
    
    let totalMinutes = hours * 60 + minutes;
    if (period === 'PM' && hours !== 12) totalMinutes += 12 * 60;
    if (period === 'AM' && hours === 12) totalMinutes = minutes;
    
    return totalMinutes;
  } catch (error) {
    return null;
  }
};

export const calculateAvailability = (building, rooms, courseData, timeRange = null) => {
  try {
    const currentTime = new Date();
    const currentDay = currentTime.toLocaleDateString('en-US', { weekday: 'long' });
    const currentMinutes = currentTime.getHours() * 60 + currentTime.getMinutes();
    
    let availableCount = 0;
    let totalClassesToday = 0;

    Object.entries(rooms).forEach(([room]) => {
      try {
        // Filter courses for this room
        const roomCourses = Object.values(courseData)
          .flat()
          .filter(course => {
            if (building === 'MLU') {
              const courseRoom = course.Room?.trim() || '';
              const courseBuilding = course.Building?.trim() || '';
              
              // Check if either the building or room contains MLU
              const isMLURoom = courseRoom.startsWith('MLU') || courseBuilding === 'MLU';
              
              // Extract room number for comparison
              const roomNumber = courseRoom.startsWith('MLU') ? 
                courseRoom.substring(3) : courseRoom;
              
              return isMLURoom && 
                     roomNumber === room &&
                     course.Days.includes(currentDay);
            } else {
              return course.Building === building && 
                     course.Room === room &&
                     course.Days.includes(currentDay);
            }
          })
          .sort((a, b) => {
            const [aStart] = a['Time Range'].split(' - ');
            const [bStart] = b['Time Range'].split(' - ');
            return parseTimeString(aStart) - parseTimeString(bStart);
          });

        totalClassesToday += roomCourses.length;

        // Check if room is occupied
        let isOccupied = false;
        let nextClassStart = null;

        for (const course of roomCourses) {
          try {
            const [startTime, endTime] = course['Time Range'].split(' - ');
            const startMinutes = parseTimeString(startTime);
            const endMinutes = parseTimeString(endTime);

            if (startMinutes === null || endMinutes === null) continue;

            if (timeRange) {
              // Check if selected time range overlaps with class time
              const rangeStart = timeRange.start;
              const rangeEnd = rangeStart + timeRange.duration;
              if (rangeStart < endMinutes && rangeEnd > startMinutes) {
                isOccupied = true;
                break;
              }
            } else {
              // Check current time
              if (currentMinutes >= startMinutes && currentMinutes < endMinutes) {
                isOccupied = true;
                break;
              }
              
              // Find next class start time
              if (startMinutes > currentMinutes) {
                if (nextClassStart === null || startMinutes < nextClassStart) {
                  nextClassStart = startMinutes;
                }
              }
            }
          } catch (error) {
          }
        }

        // Only count as available if there's no upcoming class within 30 minutes
        if (!isOccupied && (!nextClassStart || nextClassStart - currentMinutes >= 30)) {
          availableCount++;
        }
      } catch (error) {
      }
    });

    return { available: availableCount, totalClasses: totalClassesToday };
  } catch (error) {
    return { available: 0, totalClasses: 0 };
  }
};